import React from 'react';
import { MobxContext } from 'mobx/mobxContext';
import mobxStore from 'mobx/rootStore';

export default function MobxContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <MobxContext.Provider
      value={{
        mobxStore: mobxStore,
      }}
    >
      {children}
    </MobxContext.Provider>
  );
}
